import React from 'react';
import { motion } from 'framer-motion';
import CompanyLogo from '../assets/gwh.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faGithub, faLinkedin, faInstagram, faYoutube, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const footerVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 }
};

const footerTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
};

const Footer = () => {
    return (
        <motion.footer
            initial="initial"
            animate="in"
            exit="out"
            variants={footerVariants}
            transition={footerTransition}
            className="bg-gray-800 text-white py-6"
        >
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap justify-between items-start mt-10">
                    <div className="w-full md:w-1/3 mb-6 md:mb-0">
                        <img src={CompanyLogo} alt="Company Logo" className="mb-4 max-w-full h-auto" />
                        <div className="flex flex-col">
                            <div className="mb-4">
                                <p>1/III, Malayadipatti,</p>
                                <p>Rajapalayam - 626 117</p>
                                <p>Virudhunagar District</p>
                                <p>Tamil Nadu, India</p>
                                <p>Sales: +91-73587-61145,46</p>
                                <p>Mobile: +91-93449-03116/15</p>
                            </div>
                            <div className="mt-3 relative md:max-w-sm" style={{ paddingBottom: '56.25%', height: 0 }}>
                                <iframe 
                                    src="https://www.youtube.com/embed/gs8qfL9PNac?si=tDlFziQZhZhi7Op2" 
                                    title="YouTube video player" 
                                    frameBorder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    referrerPolicy="strict-origin-when-cross-origin" 
                                    allowFullScreen
                                    style={{
                                        border: 0, 
                                        position: 'absolute', 
                                        top: 0, 
                                        left: 0, 
                                        width: '100%', 
                                        height: '100%'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="w-full sm:w-1/3 mb-6 md:mb-0">
                        <div className="relative" style={{ paddingBottom: '75%', height: 0 }}>
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3143291.0063617355!2d77.56266!3d9.450027!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06c278adef43f1%3A0xfe278273604740c5!2sGowri%20House%20Metal%20Works!5e1!3m2!1sen!2sin!4v1729505319558!5m2!1sen!2sin" 
                                style={{
                                    border: 0, 
                                    position: 'absolute', 
                                    top: 0, 
                                    left: 0, 
                                    width: '100%', 
                                    height: '100%'
                                }}
                                allowFullScreen 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                            
                        </div>
                    </div>

                    <div className="w-full md:w-1/3 text-center md:text-right">
                        <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
                        <div className="flex flex-col items-start md:items-end mb-2">
                            <div className="flex items-center mb-2">
                                <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-xl" />
                                <p className="text-base">sales@gowrihouse.com</p>
                            </div>
                            <div className="flex items-center mb-2">
                                <FontAwesomeIcon icon={faPhone} className="mr-2 text-xl" />
                                <p className="text-base">+91-4563-235656</p>
                            </div>
                            
                            <div className="flex items-center mb-2">
                                <FontAwesomeIcon icon={faClock} className="mr-2 text-xl" />
                                <p className="text-base">9:00AM-6:00PM </p>
                            </div>
                            
                        </div>
                        

                        <div className="flex flex-col items-center font-bold md:items-end mt-6 space-y-4">
                            <h2 className="text-white">Follow us on social media</h2>
                            <div className="flex space-x-4">
                                <a href="https://www.instagram.com/gowri_house/" className="text-white hover:text-gray-400">
                                    <FontAwesomeIcon icon={faInstagram} className="text-2xl" />
                                </a>
                                <a href="https://www.youtube.com/@GowriHouse" className="text-white hover:text-gray-400">
                                    <FontAwesomeIcon icon={faYoutube} className="text-2xl" />
                                </a>
                                <a href="https://www.facebook.com/share/1Bd1WvuxEt/" className="text-white hover:text-gray-400">
                                    <FontAwesomeIcon icon={faFacebook} className="text-2xl" />
                                </a>
                                <a href="https://www.linkedin.com/company/gowrihouse-metal-works/" className="text-white hover:text-gray-400">
                                    <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
                                </a>
                                <a href="https://wa.me/7358761147" className="text-white hover:text-gray-400">
                                    <FontAwesomeIcon icon={faWhatsapp} className="text-2xl" />
                                </a>

                            </div>
                            
                                <div className="flex flex-col">
                                    <h2>Click Below to Get as a Brochure</h2>
                                    <div className="flex flex-col gap-3 mt-2">
                                        <a
                                        href="/gwhllp-broucher.pdf"
                                        download
                                        className="inline-flex items-center gap-2 px-4 py-2 border-2 border-blue-500 rounded-2xl text-blue-700 font-semibold hover:bg-blue-500 hover:text-white transition-all duration-300 shadow-md"
                                        >
                                        📥 Download Brochure 
                                        </a>
                                        <h2>Click here to view Catalogue</h2>

                                        <a
                                        href="/gwhllp-catalogue.pdf"
                                        download
                                        className="inline-flex items-center gap-2 px-4 py-2 border-2 border-blue-500 rounded-2xl text-blue-700 font-semibold hover:bg-blue-500 hover:text-white transition-all duration-300 shadow-md"
                                        >
                                        📥 Download Catalogue
                                        </a>
                                    </div>
                                </div>


                        </div>

                    </div>
                </div>
                <div className="mt-8 text-center">
                    <p>&copy; {new Date().getFullYear()} Gowri House Metal Works. All rights reserved.</p>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;